var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 4.33333H19.1113M14.6668 4.33333L14.3662 3.43119C14.0747 2.55694 13.9289 2.11982 13.6587 1.79664C13.4201 1.51126 13.1136 1.29036 12.7674 1.1542C12.3753 1 11.9146 1 10.9931 1H9.45172C8.53016 1 8.0695 1 7.6774 1.1542C7.33118 1.29036 7.0247 1.51126 6.78604 1.79664C6.51577 2.11982 6.37007 2.55694 6.07865 3.43119L5.77794 4.33333M16.8891 4.33333V15.6667C16.8891 17.5336 16.8891 18.4669 16.5257 19.18C16.2062 19.8072 15.6963 20.3171 15.0691 20.6367C14.3559 21 13.4226 21 11.5557 21H8.88905C7.02221 21 6.08878 21 5.37575 20.6367C4.74854 20.3171 4.23861 19.8072 3.91903 19.18C3.55572 18.4669 3.55572 17.5336 3.55572 15.6667V4.33333M12.4446 8.77778V16.5556M8.00016 8.77778V16.5556",
    stroke: "#DC3545",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.5c3843d1497e9812fd783b0b7425146c.svg";
export { ForwardRef as ReactComponent };